import {
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import AppCard from 'presentation/components/shared/card/AppCard';
import GridHeading from 'presentation/components/shared/grid/GridHeading';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  competitors: PeCompanyCompetitorItem[];
}

const PeCompanyCompetitorsTable: FC<Props> = ({ competitors }) => {
  const { t } = useTranslation();

  const hasRevenueGrowthType = competitors.some(
    (item) => item.revenueGrowthType
  );
  const hasInvestmentsIncome = competitors.some(
    (item) => item.investmentIncome
  );
  const hasEmployeesTotal = competitors.some((item) => item.employeesTotal);

  return (
    <>
      <GridHeading>{t('peCompanyCompetitors')}</GridHeading>
      <AppCard p="20px">
        <TableContainer w="100%">
          <Table>
            <Thead>
              <Tr>
                <Th />
                {competitors.map((item, index) => (
                  <Th key={index}>{item.name}</Th>
                ))}
              </Tr>
            </Thead>
            <Tbody>
              <Tr>
                <Td>
                  <Text fontWeight={700}>{t('peCompetitorsEstimate')}</Text>
                </Td>
                {competitors.map((item, index) => (
                  <Td key={index}>{item.estimate}</Td>
                ))}
              </Tr>
              <Tr>
                <Td>
                  <Text fontWeight={700}>{t('peCompetitorsStockType')}</Text>
                </Td>
                {competitors.map((item, index) => (
                  <Td key={index}>{item.stockType}</Td>
                ))}
              </Tr>
              {hasRevenueGrowthType && (
                <Tr>
                  <Td>
                    <Text fontWeight={700}>
                      {t('peCompetitorsTypeOfRevenueGrowth')}
                    </Text>
                  </Td>
                  {competitors.map((item, index) => (
                    <Td key={index}>{item.revenueGrowthType ?? '-'}</Td>
                  ))}
                </Tr>
              )}
              {hasInvestmentsIncome && (
                <Tr>
                  <Td>
                    <Text fontWeight={700}>{t('peCompetitorsRaised')}</Text>
                  </Td>
                  {competitors.map((item, index) => (
                    <Td key={index}>{item.investmentIncome ?? '-'}</Td>
                  ))}
                </Tr>
              )}
              {hasEmployeesTotal && (
                <Tr>
                  <Td>
                    <Text fontWeight={700}>{t('peCompetitorsEmployees')}</Text>
                  </Td>
                  {competitors.map((item, index) => (
                    <Td key={index}>{item.employeesTotal ?? '-'}</Td>
                  ))}
                </Tr>
              )}
              <Tr>
                <Td>
                  <Text fontWeight={700}>{t('peCompetitorsCountry')}</Text>
                </Td>
                {competitors.map((item, index) => (
                  <Td key={index}>{item.country}</Td>
                ))}
              </Tr>
              <Tr>
                <Td>
                  <Text fontWeight={700}>{t('peCompetitorsFoundation')}</Text>
                </Td>
                {competitors.map((item, index) => (
                  <Td key={index}>{item.foundationYear}</Td>
                ))}
              </Tr>
            </Tbody>
          </Table>
        </TableContainer>
      </AppCard>
    </>
  );
};

export default PeCompanyCompetitorsTable;
